const PERMISSION_KEY= "notification:notification_module";
const PAGE_URL = {
    NOTIFICATION_MODULE_PAGE: "/admin/notification/notification-module"
}

export {PERMISSION_KEY, PAGE_URL}

